export const formatDate = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();


    return `${day}-${month}-${year}`;
};
// export const formatDatewithMonth = (date) => {
//     if (!date || date === '-') return '';
//     const dateObj = new Date(date);
//     if (isNaN(dateObj.getTime())) return '';
export const formatDatewithMonth = (dateString,two_digit = false) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
            return dateString;
        }
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        // Get day, month and year
        const day = date.getDate().toString().padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const formattedYear = two_digit ? String(year).slice(-2) : year;

        // Return formatted date
        return `${day} ${month} ${formattedYear}`;
        
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
};
